/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter } from './TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter';
import {
    TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSON,
    TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSONTyped,
    TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterToJSON,
} from './TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter';

/**
 * 
 * @export
 * @interface TrackItMeasurementParameterFilterWithMatchingValueDto
 */
export interface TrackItMeasurementParameterFilterWithMatchingValueDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    isEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    isCustom?: boolean;
    /**
     * 
     * @type {TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    measurementParameter?: TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    dataTypeId: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    geometryId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    groupHash: string;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterFilterWithMatchingValueDto
     */
    $type?: TrackItMeasurementParameterFilterWithMatchingValueDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterFilterWithMatchingValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterFilterWithMatchingValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterFilterWithMatchingValueDtoTypeEnum = typeof TrackItMeasurementParameterFilterWithMatchingValueDtoTypeEnum[keyof typeof TrackItMeasurementParameterFilterWithMatchingValueDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterFilterWithMatchingValueDto interface.
 */
export function instanceOfTrackItMeasurementParameterFilterWithMatchingValueDto(value?: unknown): value is TrackItMeasurementParameterFilterWithMatchingValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterFilterWithMatchingValueDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSON(json: any): TrackItMeasurementParameterFilterWithMatchingValueDto {
    return TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterFilterWithMatchingValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isCustom': json['isCustom'] == null ? undefined : json['isCustom'],
        'measurementParameter': json['measurementParameter'] == null ? undefined : TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSON(json['measurementParameter']),
        'dataTypeId': json['dataTypeId'],
        'geometryId': json['geometryId'] == null ? undefined : json['geometryId'],
        'groupHash': json['groupHash'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterFilterWithMatchingValueDtoToJSON(value?: TrackItMeasurementParameterFilterWithMatchingValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'isEnabled': value['isEnabled'],
        'isCustom': value['isCustom'],
        'measurementParameter': TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterToJSON(value['measurementParameter']),
        'dataTypeId': value['dataTypeId'],
        'geometryId': value['geometryId'],
        'groupHash': value['groupHash'],
        '$type': value['$type'],
    });
}

